// extracted by mini-css-extract-plugin
module.exports = {"layout":"_35875ce240--layout--SHgMu","spinner":"_35875ce240--spinner--CczFU","container":"_35875ce240--container--qDhh7","error":"_35875ce240--error--_bpHQ"};